import Api from 'App/api'

export const getClassifiedsWithSettings = Api.get({
  controller: 'classifieds',
  action: 'listWithSettings',
})

export const getClassifieds = Api.get({
  controller: 'classifieds',
  action: 'list',
})

export const getMyAds = Api.get({
  controller: 'classifieds',
  action: 'listMyAds',
})

export const getMyFavorites = Api.get({
  controller: 'classifieds',
  action: 'listFavorites',
})

export const addFavorite = Api.post({
  controller: 'classifieds',
  action: 'addFavorite',
})

export const removeFavorite = Api.post({
  controller: 'classifieds',
  action: 'removeFavorite',
})

export const deleteClassified = Api.post({
  controller: 'classifieds',
  action: 'delete',
})

export const saveClassified = Api.postMultipart({
  controller: 'classifieds',
  action: 'save',
})

export const getClassifiedImageUrl = Api.get({
  controller: 'classifieds',
  action: 'viewImage',
})

export const sendMessage = Api.post({
  controller: 'classifieds',
  action: 'sendMessage',
})
